// extracted by mini-css-extract-plugin
export default {"container":"CustomerService_container__FqQbt","filtersContainer":"CustomerService_filtersContainer__jSE4P"};